import React from "react";
import {useTranslate} from "@tolgee/react";
import LomavisUpgradeSubscriptionPageLink from "../../../billing/utils/openSubscriptionPageLink";

interface LomavisAiAssistantUpgradeHintProps {
    text: string;
}

const LomavisAiAssistantUpgradeHint: React.FC<LomavisAiAssistantUpgradeHintProps> = (
    {
        text
    }
) => {
    const { t } = useTranslate();

    return (
        <div className="alert alert-danger d-flex flex-row justify-content-between">
            <div>{t(text)}</div>
            <div><LomavisUpgradeSubscriptionPageLink /></div>
        </div>
    )

};

export default LomavisAiAssistantUpgradeHint;